import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { BiUserCircle } from 'react-icons/bi';
import Hamburger from 'components/Navbar/Hamburger';
import { useAppSelector } from 'hooks/useStore';
import './index.css';

function Navbar({ transparent }: { transparent: boolean; }) {
    const { authenticated } = useAppSelector(state => state.user);
    const { organization } = useAppSelector(state => state.organization);

    const activeLinkClassName = transparent
        ? 'navbar__link--active--transparent'
        : 'navbar__link--active';

    return (
        <div className={transparent ? 'navbar--transparent' : 'navbar'}>
            <div className='navbar__content'>
                <Link to='/'>
                    <img 
                        // src={TSCCLogo} 
                        src={organization.logo}
                        alt={organization.name}
                        className='navbar__logo'
                    />
                </Link>
                <div className='navbar__links'>
                    <NavLink
                        to='/tests/digital-act'
                        className={({ isActive }) => (isActive
                            ? activeLinkClassName
                            : organization.backgroundColor
                            ? 'navbar__link--light'
                            : 'navbar__link'
                        )}
                    >
                        ACT
                    </NavLink>
                    <NavLink
                        to='/tests/digital-sat'
                        className={({ isActive }) => (isActive
                            ? activeLinkClassName
                            : organization.backgroundColor
                            ? 'navbar__link--light'
                            : 'navbar__link'
                        )}
                    >
                        SAT
                    </NavLink>
                    <NavLink
                        to='/tests/digital-psat'
                        className={({ isActive }) => (isActive
                            ? activeLinkClassName
                            : organization.backgroundColor
                            ? 'navbar__link--light'
                            : 'navbar__link'
                        )}
                    >
                        PSAT
                    </NavLink>
                    {authenticated
                        ?   <>
                                <NavLink
                                    to='/account'
                                    className={({ isActive }) => (isActive
                                        ? activeLinkClassName
                                        : organization.backgroundColor
                                        ? 'navbar__link--light'
                                        : 'navbar__link'
                                    )}
                                >
                                    <BiUserCircle className='navbar__icon' />
                                </NavLink>
                            </>
                        :   <NavLink 
                                to="/sign-in"
                                className={({ isActive }) => (isActive
                                    ? activeLinkClassName
                                    : organization.backgroundColor
                                    ? 'navbar__link--light'
                                    : 'navbar__link'
                                )}
                            >
                                Sign In
                            </NavLink>
                    }
                </div>
                <Hamburger transparent={transparent} />
            </div>
        </div>
    );
}

export default Navbar;